/* global $ */

import toArray from '../helpers/toArray';

const $cartModal = $('#cartModal');
const $quantity = $('.js-product-quantity');
const $productSubmit = $('.js-product-submit');
const $outputRelatedProducts = $('.js-output-related-products');
const $outputMaintenanceContract = $('.js-maintenance-contract');
const $outputMaintenanceContractCheckbox = $('.js-maintenance-contract-checkbox');

const productSubmit = {
  initialize() {
    if (!$productSubmit.length) {
      return;
    }

    $productSubmit.on('submit', (e) => {
      e.preventDefault();
      this.submit(e.currentTarget);
    });
  },

  submit(target) {
    const $target = $(target);

    this.sendCartUpdate($target.attr('action'), $target.serialize(), $target.get(0));
    this.getRelatedProducts('/api/related-products', $target.serialize());
  },

  sendCartUpdate(action, serializedData, form) {
    const productItemObj = JSON.parse(form.dataset.gtmArray);

    productItemObj.quantity = parseInt($quantity.val(), 10);

    if (Number.isNaN(productItemObj.quantity)) {
      productItemObj.quantity = 1;
    }

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'addToCart',
        currency: 'EUR',
        value: (productItemObj.price * productItemObj.quantity).toFixed(2),
        items: [
          productItemObj,
        ],
      });
    }

    $.ajax({
      url: action,
      type: 'POST',
      data: serializedData,
      dataType: 'json',
      success: (res) => {
        const itemsCount = res.items_count;

        this.getMainenanceContract('/api/maintenance-contract', serializedData);

        this.outputCount(itemsCount);

        $cartModal.modal('show');
      },
    });
  },

  getMainenanceContract(action, serializedData) {
    $.ajax({
      url: action,
      type: 'POST',
      data: serializedData,
      success: (res) => {
        $outputMaintenanceContract.toggle(res.productHasMaintenanceContract);
        $outputMaintenanceContractCheckbox.prop('checked', res.hasMaintenanceContract);
      },
    });
  },

  getRelatedProducts(action, serializedData) {
    $.ajax({
      url: action,
      type: 'POST',
      data: serializedData,
      success: (res) => {
        $outputRelatedProducts.html(res);

        $('[data-toggle="popover"]').popover({
          trigger: 'hover',
        });
      },
    });
  },

  outputCount(count) {
    if (Number.isNaN(parseInt(count, 10))) {
      return;
    }

    const output = toArray(document.querySelectorAll('.js-navigation-cart-item-count'));

    output.forEach((element) => {
      element.innerText = count;
    });
  },
};

export default productSubmit;
